document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('#GrandLineBookingForm');
  if (!form) return;

  const dateInput = form.querySelector('input[type="date"]');
  if (dateInput) {
    const now = new Date();
    const localDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000);
    dateInput.min = localDate.toISOString().slice(0, 10);
  }

  form.addEventListener('submit', () => {
    const button = form.querySelector('.gl-submit');
    if (!button) return;
    button.disabled = true;
    button.textContent = 'Sending request…';
  });
});